/**
 * @since 2024-05-05
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import ModalPasswordChange from "./ModalPasswordChange";

export default ModalPasswordChange;
